const WATERMARK_PREFIX = "surf.sync.watermark.";
export function surfWatermarkStorageKey(accountKey) {
    return `${WATERMARK_PREFIX}${accountKey}`;
}
export function readWatermark(storage, accountKey) {
    return storage.getItem(surfWatermarkStorageKey(accountKey)) ?? "";
}
export function writeWatermark(storage, accountKey, syncedAt) {
    if (!syncedAt.trim())
        return;
    storage.setItem(surfWatermarkStorageKey(accountKey), syncedAt);
}
export function accountKeyFromJwtClaims(iss, sub) {
    return `${iss}|${sub}`;
}
export function parseAccountKeyFromIdToken(idToken, decode) {
    const payload = decode(idToken);
    if (!payload)
        return null;
    const iss = String(payload.iss ?? "").trim();
    const sub = String(payload.sub ?? "").trim();
    if (!iss || !sub)
        return null;
    return accountKeyFromJwtClaims(iss, sub);
}
